
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: Array,
      default: null,
    },
    index: {
      type: Number,
      default: 0,
    },
    activeIndex: {
      type: Number,
      default: null,
    },
    htmlText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      height: 0,
      labelMargin: 32,
    };
  },
  computed: {
    listHeight() {
      return `height: ${this.height}px`;
    },
    open() {
      if (this.index === this.activeIndex) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    open(open) {
      if (!open) {
        this.height = this.$refs.label.clientHeight;
      } else {
        this.height =
          this.$refs.label.clientHeight + this.$refs.content.clientHeight;
      }
    },
  },
  mounted() {
    this.height = this.$refs.label.clientHeight;
  },
};
